import { fetchGraphQL } from "./libs";
const setApplyBtn = async () => {
  const pakurosuContainer = document.querySelector('#js-pakurosu-btn-container'),
    logicContainer = document.querySelector('#js-logic-btn-container');
  if (!pakurosuContainer && !logicContainer) return false;

  const GET_POSTS = `
    {
      settingsPost(id: 121, idType: DATABASE_ID) {
        linkSettings {
          pakurosu {
            pakurosuBtnList {
              pakurosuBtnLink
              pakurosuBtnText
            }
          }
          logic {
            logicBtnList {
              logicBtnLink
              logicBtnText
            }
          }
        }
      }
    }
  `;

  const res = await fetchGraphQL(GET_POSTS, { first: 5 }),
    targetData = res.settingsPost.linkSettings,
    btnData = pakurosuContainer ? targetData.pakurosu.pakurosuBtnList : logicContainer ? targetData.logic.logicBtnList : null;

  if (btnData) {
    let html = ``;
    btnData.forEach(data => {
      const link = pakurosuContainer ? data.pakurosuBtnLink : data.logicBtnLink,
        text = pakurosuContainer ? data.pakurosuBtnText : data.logicBtnText;
      html += `
                <div class="p-apply-detail__btn">
                  <a href="${link}" class="c-btn-grn-large">${text}<i class="c-arrow-grn-large"></i></a>
                </div>`;
    });

    if (pakurosuContainer) {
      pakurosuContainer.innerHTML = html;
    } else {
      logicContainer.innerHTML = html;
    }
  }
};

export default setApplyBtn;